import React from "react";
import "./reviews.scss";
import { Rating, Skeleton } from "@mui/material";
import dateformat from "dateformat";
import userStore from "../../store/userStore";

// icon
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import VerifiedRoundedIcon from "@mui/icons-material/VerifiedRounded";
import { useState } from "react";
import { useEffect } from "react";
import authStore from "../../store/authStore";

const Reviews = ({ item }) => {
  const UserStore = userStore();
  const AuthStore = authStore();

  const [username, setUsername] = useState();

  useEffect(() => {
    if (item.userID) {
      const user = UserStore.allUser.find((user) => item.userID === user._id);
      if (user) {
        if (AuthStore.isLogged && AuthStore.myUser._id === user._id) {
          setUsername(`${user.firstName} ${user.lastName} (Me)`);
        } else {
          setUsername(`${user.firstName} ${user.lastName}`);
        }
      } else {
        setUsername(item.username);
      }
    } else {
      setUsername(item.username);
    }

    UserStore.allUser.map((user) => {
      if (user._id === item.userID) {
        if (AuthStore.isLogged && AuthStore.myUser._id === item.userID) {
          setUsername(`${user.firstName} ${user.lastName} (Me)`);
        } else {
          setUsername(`${user.firstName} ${user.lastName}`);
        }
      }
    });
  }, []);

  return (
    <div className="customer-reviews">
      <div className="customer-reviews-details">
        <div className="customer-name">
          <h4>
            {username ? username : <Skeleton animation="wave" width="100px" />}
          </h4>
          <p>{dateformat(new Date(item.created_at), "dd mmm yyyy")}</p>
        </div>
        <div className="rating">
          <Rating
            name="read-only"
            value={item.rating}
            readOnly
            sx={{ fontSize: "23px" }}
            icon={<StarRoundedIcon fontSize="inherit" />}
            emptyIcon={<StarRoundedIcon fontSize="inherit" />}
          />
        </div>
        <div className="verified-purchase">
          <VerifiedRoundedIcon className="icon" /> <p>Verified purchase</p>
        </div>
        <div className="review-description">
          <p>{item.review}</p>
        </div>
        {/* <div className="like-dislike">
          <ThumbUpOutlinedIcon className="icon" /> <span>123</span>{" "}
          <ThumbDownOutlinedIcon className="icon" /> <span>34</span>
        </div> */}
      </div>
    </div>
  );
};

export default Reviews;
